// AUTO-GENERATED by tao2/convert_tao2.py — do not edit by hand.
// Source of truth: "tao two - modified.docx".

export const TAO2_TOC = [
  {
    "id": "hitting-harder-more-power",
    "title": "Hitting Harder (more power)",
    "level": 2
  },
  {
    "id": "1-advice-for-kicking-combinations-with-same-leg",
    "title": "[1] Advice for Kicking Combinations (with same leg)",
    "level": 3
  },
  {
    "id": "2-leg-destruction-techniques",
    "title": "[2] Leg Destruction Techniques",
    "level": 3
  },
  {
    "id": "3-advanced-kicking",
    "title": "[3]    Advanced Kicking",
    "level": 3
  },
  {
    "id": "4-triple-striking",
    "title": "[4]   Triple Striking",
    "level": 3
  },
  {
    "id": "5-the-feint",
    "title": "[5] The Feint",
    "level": 3
  },
  {
    "id": "6-initiating-a-fracas",
    "title": "[6] Initiating a Fracas",
    "level": 3
  },
  {
    "id": "7-striking-the-eyes",
    "title": "[7] Striking the Eyes",
    "level": 3
  },
  {
    "id": "8-ground-fighting-closed-door",
    "title": "[8] Ground Fighting (closed door)",
    "level": 3
  },
  {
    "id": "9-basic-attacks",
    "title": "[9] Basic attacks",
    "level": 3
  },
  {
    "id": "10-untitled",
    "title": "[10] (Untitled)",
    "level": 3
  },
  {
    "id": "11-defensive-strategy",
    "title": "[11] Defensive Strategy",
    "level": 3
  },
  {
    "id": "12-foot-sweeps",
    "title": "[12] Foot Sweeps",
    "level": 3
  },
  {
    "id": "13-low-kicks",
    "title": "[13] Low Kicks",
    "level": 3
  },
  {
    "id": "14-when-not-to-kick",
    "title": "[14] When Not to Kick",
    "level": 3
  },
  {
    "id": "15-when-not-to-grapple",
    "title": "[15] When not to Grapple",
    "level": 3
  },
  {
    "id": "16-close-quarter",
    "title": "[16] Close Quarter",
    "level": 3
  },
  {
    "id": "17-straight-fingers",
    "title": "[17] Straight Fingers",
    "level": 3
  },
  {
    "id": "18-heel-of-the-foot-kicking",
    "title": "[18] Heel of the Foot Kicking",
    "level": 3
  },
  {
    "id": "19-ball-of-the-foot-kicking",
    "title": "[19] Ball of the Foot Kicking",
    "level": 3
  },
  {
    "id": "20-trips-and-take-downs",
    "title": "[20] Trips and Take Downs",
    "level": 3
  },
  {
    "id": "21-short-range-low-kicking",
    "title": "[21] Short Range Low - Kicking",
    "level": 3
  },
  {
    "id": "22-elbow-and-forearm",
    "title": "[22] Elbow and Forearm",
    "level": 3
  },
  {
    "id": "23-one-knuckle-punches",
    "title": "[23] One Knuckle Punches",
    "level": 3
  },
  {
    "id": "24-feng-yen",
    "title": "[24] Feng - Yen",
    "level": 3
  },
  {
    "id": "25-circular-technique",
    "title": "[25] Circular Technique",
    "level": 3
  },
  {
    "id": "26-hand-and-foot-attacks-combinations",
    "title": "[26] Hand and Foot Attacks (combinations)",
    "level": 3
  },
  {
    "id": "27-stamping-knee-shin-ankle-instep-etc",
    "title": "[27] Stamping - KNEE, SHIN, ANKLE, INSTEP etc...",
    "level": 3
  },
  {
    "id": "28-nerve-grabbing",
    "title": "[28] Nerve Grabbing",
    "level": 3
  },
  {
    "id": "29-hitting-the-thigh",
    "title": "[29] Hitting the Thigh",
    "level": 3
  },
  {
    "id": "30-shoving",
    "title": "[30] Shoving",
    "level": 3
  },
  {
    "id": "31-single-arm-push",
    "title": "[31] Single Arm Push",
    "level": 3
  },
  {
    "id": "32-superior-distance",
    "title": "[32] Superior Distance",
    "level": 3
  },
  {
    "id": "33-jump-axe-kick",
    "title": "[33] Jump Axe Kick",
    "level": 3
  },
  {
    "id": "34-fitness",
    "title": "[34] FITNESS",
    "level": 3
  },
  {
    "id": "35-muscle-body-building-weights",
    "title": "[35] Muscle (body building weights)",
    "level": 3
  },
  {
    "id": "36-close-range-openers",
    "title": "[36] Close Range Openers",
    "level": 3
  },
  {
    "id": "37-controlling",
    "title": "[37] Controlling",
    "level": 3
  },
  {
    "id": "38-as-a-defence",
    "title": "[38] As A Defence",
    "level": 3
  },
  {
    "id": "39-attack-smaller-opponent",
    "title": "[39] Attack (smaller opponent)",
    "level": 3
  },
  {
    "id": "40-attack-larger-opponent",
    "title": "[40] Attack (larger opponent)",
    "level": 3
  },
  {
    "id": "41-depth-of-impact",
    "title": "[41] Depth of Impact",
    "level": 3
  },
  {
    "id": "42-high-kicking-head-etc",
    "title": "[42] High Kicking (head etc)",
    "level": 3
  },
  {
    "id": "43-distraction",
    "title": "[43] Distraction",
    "level": 3
  },
  {
    "id": "44-entry-and-exit-techniques",
    "title": "[44] Entry and Exit Techniques",
    "level": 3
  },
  {
    "id": "45-interspersed-power",
    "title": "[45] Interspersed Power",
    "level": 3
  },
  {
    "id": "47-conditioning",
    "title": "[47] Conditioning",
    "level": 3
  },
  {
    "id": "48-variable-speed",
    "title": "[48] Variable Speed",
    "level": 3
  },
  {
    "id": "49-arm-kicking",
    "title": "[49] Arm Kicking",
    "level": 3
  },
  {
    "id": "50-securing-your-perimeter",
    "title": "[50] Securing Your Perimeter",
    "level": 3
  },
  {
    "id": "51-in-analysis",
    "title": "[51] In Analysis",
    "level": 3
  },
  {
    "id": "52-slowing-your-opponent",
    "title": "[52] Slowing your Opponent",
    "level": 3
  },
  {
    "id": "53-important-points-to-watch",
    "title": "[53] Important Points to Watch",
    "level": 3
  },
  {
    "id": "54-destructive-kicks",
    "title": "[54] Destructive Kicks",
    "level": 3
  },
  {
    "id": "56-leg-destruction",
    "title": "[56] Leg Destruction",
    "level": 3
  },
  {
    "id": "57-destruction-of-the-lead-arm",
    "title": "[57] Destruction of the Lead Arm",
    "level": 3
  },
  {
    "id": "58-single-knuckle",
    "title": "[58] Single Knuckle",
    "level": 3
  },
  {
    "id": "59-hitting-the-mid-section",
    "title": "[59] Hitting the Mid - Section",
    "level": 3
  },
  {
    "id": "60-liver-hitting",
    "title": "[60] Liver Hitting",
    "level": 3
  },
  {
    "id": "61-kidney-hitting",
    "title": "[61] Kidney Hitting",
    "level": 3
  },
  {
    "id": "62-carotid-artery-hitting",
    "title": "[62] Carotid Artery Hitting",
    "level": 3
  },
  {
    "id": "63-elbows",
    "title": "[63] Elbows",
    "level": 3
  },
  {
    "id": "64-turning-and-jump-turning-kicks",
    "title": "[64] Turning and Jump Turning Kicks",
    "level": 3
  },
  {
    "id": "65-fan-hand",
    "title": "[65] Fan Hand",
    "level": 3
  },
  {
    "id": "66-utilising-arm-damage-through-kicking",
    "title": "[66] Utilising Arm Damage through Kicking",
    "level": 3
  },
  {
    "id": "67-kicking-as-a-stop-gap",
    "title": "[67] Kicking as a Stop-Gap",
    "level": 3
  },
  {
    "id": "68-attacking-the-neck",
    "title": "[68] Attacking the Neck",
    "level": 3
  },
  {
    "id": "69-foot-stamping",
    "title": "[69] Foot Stamping",
    "level": 3
  },
  {
    "id": "70-throws",
    "title": "[70] Throws",
    "level": 3
  },
  {
    "id": "71-maintaining-vigilance",
    "title": "[71] Maintaining Vigilance",
    "level": 3
  },
  {
    "id": "72-hitting",
    "title": "[72] Hitting",
    "level": 3
  },
  {
    "id": "73-the-press",
    "title": "[73] The Press",
    "level": 3
  },
  {
    "id": "74-deflections",
    "title": "[74] Deflections",
    "level": 3
  },
  {
    "id": "75-punishment",
    "title": "[75] Punishment",
    "level": 3
  },
  {
    "id": "76-trapping",
    "title": "[76] Trapping",
    "level": 3
  },
  {
    "id": "78-hair-pulling",
    "title": "[78] Hair Pulling",
    "level": 3
  },
  {
    "id": "79-the-gap",
    "title": "[79] The Gap",
    "level": 3
  },
  {
    "id": "80-flicking",
    "title": "[80] Flicking",
    "level": 3
  },
  {
    "id": "81-target-opportunity",
    "title": "[81] Target Opportunity",
    "level": 3
  }
];

export const TAO2_HTML = `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1" />
<title>Tao II</title>
<link rel="preconnect" href="https://fonts.googleapis.com" /><link rel="preconnect" href="https://fonts.gstatic.com" crossorigin /><link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Libre+Baskerville:ital,wght@0,400;0,700;1,400&family=Literata:ital,opsz,wght@0,7..72,400;0,7..72,600;0,7..72,700;1,7..72,400&family=Merriweather:ital,opsz,wght@0,18..144,300;0,18..144,400;0,18..144,700;1,18..144,400&family=Newsreader:ital,opsz,wght@0,6..72,400;0,6..72,600;0,6..72,700;1,6..72,400&family=Source+Serif+4:ital,opsz,wght@0,8..60,400;0,8..60,600;0,8..60,700;1,8..60,400&display=swap" />
<style>
:root {
  --ink: #2b2622;
  --paper: #f7f1e4;
  --gold: #b8942f;
  --gold-bright: #d4af37;
  --maxw: 46rem;
  --reader-font: "Literata", "Iowan Old Style", "Palatino Linotype", Palatino, Georgia, serif;
  --reader-size: 18px;
}
* { box-sizing: border-box; }
html { -webkit-text-size-adjust: 100%; }
body {
  margin: 0;
  background: #efe7d6;
  color: var(--ink);
  font-family: var(--reader-font);
  font-size: var(--reader-size);
  line-height: 1.7;
}
.page {
  max-width: var(--maxw);
  margin: 0 auto;
  padding: clamp(1.5rem, 4vw, 3.5rem) clamp(1.1rem, 4vw, 3rem) 5rem;
  background: var(--paper);
  min-height: 100vh;
  box-shadow: 0 0 40px rgba(0,0,0,0.08);
}
.doc-header { text-align: center; padding: 2rem 0 1rem; }
h1 {
  margin: 0;
  font-family: var(--reader-font);
  font-size: 3em;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: var(--gold-bright);
  text-shadow: 0 1px 0 rgba(0,0,0,0.08);
}
.cover {
  margin: 1.5rem auto 2.5rem;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
}
.cover img {
  max-width: min(240px, 60%);
  height: auto;
  border-radius: 6px;
  filter: drop-shadow(0 6px 16px rgba(0,0,0,0.18));
}
h2 {
  margin: 2.6em 0 0.8em;
  padding-bottom: 0.3em;
  font-family: var(--reader-font);
  font-size: 1.7em;
  font-weight: 700;
  color: var(--gold-bright);
  border-bottom: 2px solid var(--gold);
  scroll-margin-top: 1rem;
}
h3 {
  margin: 1.8em 0 0.5em;
  font-family: var(--reader-font);
  font-size: 1.25em;
  font-weight: 700;
  color: var(--gold);
  scroll-margin-top: 1rem;
}
p { margin: 0 0 1em; }
main :is(ul, ol) { margin: 0 0 1.15em; padding-left: 1.6em; }
main li { margin: 0.35em 0; }
main ul { list-style: disc; }
main ol.numbered { list-style: decimal; }
strong { font-weight: 700; color: #1f1b18; }
em { font-style: italic; }
figure { margin: 1.5em 0; text-align: center; }
figure img { max-width: 100%; height: auto; border-radius: 6px; }
::selection { background: rgba(212,175,55,0.28); }
@media (max-width: 640px) { .page { box-shadow: none; } }
</style>
</head>
<body>
<article class="page">
<header class="doc-header">
  <h1>Tao II</h1>
</header>
<figure class="cover">
  <img src="data:image/png;base64,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" alt="Tao II illustration" />
  <img src="data:image/png;base64,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" alt="Tao II illustration" />
</figure>
<main class="doc-body">
<h2 id="hitting-harder-more-power">Hitting Harder (more power)</h2>
<p>When you wish to hit with more force, aim to penetrate 2.3 or 4 inches into (inside) your target area. Don&#x27;t use strength as this slows your technique speed and makes your target area predictable, throw the blow relaxed with maximum speed and hit through your target, Push yourself forward with your rear foot, then relax your rear leg after the initial impact in order to facilitate the rapid recovery of your leg in order to kick in combination if necessary, or to regain your distance in the event of failure. If you attempt to force your arm/leg by tensing the only effect will be to push your opponent. The least effect would be to slightly hurt him, the worst, to push him out of range of a further combination by you.</p>
<p>If you can get him to step forward, or time your move so as to catch him stepping forward, you double your power. On the other hand, if he is nervous it’s almost impossible to hit him powerfully, so resort to one knuckle, and finger attacks so as to enhance the force against a rapidly retreating opponent.</p>
<p>Hit to the body more as he absorbs more power that way.</p>
<p>Strike into his legs so as to steady him as a static opponent takes more punishment than a mobile one, who can ride the blows.</p>
<h3 id="1-advice-for-kicking-combinations-with-same-leg">[1] Advice for Kicking Combinations (with same leg)</h3>
<p>Hit as rapidly as possible</p>
<p>Keep your knee as high as possible</p>
<p>In high - low combinations, always hit high first, then lower.</p>
<p>Don&#x27;t use the same strength for each kick, vary.</p>
<p>Use your hands to set angle of attack, (i.e. push to make him lean back) etc…</p>
<p>Don&#x27;t aim for nerve centre’s; instead aim for muscle groups and always at the end of a muscle group.</p>
<p>Always hit with your hands first, then kick him as he moves away and his path is predictable.</p>
<p>Don&#x27;t forget his lead body tools, strike often.</p>
<p>Always use your lightest and fastest hand work with any kicking technique, as a stopgap between slower kicks.</p>
<p>Do not use any hip, as this only slows your technique.</p>
<p>Hit his lead calf muscle as often as this hinders his movement and prevents his countering.</p>
<p>Kick the centre of his chest when possible as this occupies his hands.</p>
<h3 id="2-leg-destruction-techniques">[2] Leg Destruction Techniques</h3>
<ul>
  <li>Always attack the legs in combination.</li>
  <li>Remember the knee joint is best broken (destroyed) from the side.</li>
  <li>Kick the rear of your opponent’s knee, in order to keep his weight on it-it is easier to break,</li>
  <li>It is recommended to stun a muscle group prior to attempting a leg break.</li>
  <li>After an attempted leg break, you must follow up with a stamp.</li>
  <li>Repeated kicking of the same area is a respect getter and shows your superiority.</li>
  <li>If you&#x27;ve attacked the upper leg, the immediately attack the lower leg (shin/ankle)</li>
  <li>Kick his lead leg, then push him, to expose better targets or prior to engaging him with your hands.</li>
  <li>In some cases it is possible to kick the same area twice in a row, after a successful attack and he is momentarily stunned. Kick or stamp to get a good angle on his leg then finish, using power</li>
  <li>Push the shoulder of your adversary or jab his ribs, so he leans back and presents his leg at a more opportune angle.</li>
  <li>A foot sweep is always enhanced before or after a leg attack. Your opponent is always more compliant</li>
  <li>The instant he is downed stamp on his ankle etc</li>
  <li>If the opportunity presents itself, kick his leg, grab his shoulder or arm and pull his weight back onto his now injured leg. This now presents a good leg-breaking opportunity</li>
  <li>Kicking his leg; facilitates a trip or throw and aids in keeping him downed.</li>
</ul>
<h3 id="3-advanced-kicking">[3]    Advanced Kicking</h3>
<p>Prior to kicking your opponents head / body;</p>
<p>Strike his Lead leg.</p>
<p>Trap his lead arm.</p>
<p>Jam his lead side.</p>
<p>Cause brief hesitation by him prior to you assault.</p>
<ul>
  <li>If he is tall bend him over as this established the same criteria as above, i.e. a groin slap for instance.</li>
  <li>Always use low kicks to hinder his mobility.</li>
  <li>Use your most disabling blows as a starter - remember these blows must not require strength - just speed.</li>
  <li>Try not to use any kicks which commit your hip - only if he’s hurt should you use hip and then only conservatively.</li>
  <li>If possible try to unbalance you adversary prior to a high kick.</li>
  <li>Always disengage with a low kick.</li>
  <li>Use pain as a respect getter.</li>
  <li>Pull him then low kick.</li>
  <li>Stabilize him prior to jump kicking.</li>
  <li>Extend his arm or leg prior to attempting to break it.</li>
  <li>Remember as your front leg is returning to the ground after a successful / unsuccessful kick, use an elbow or push to maintain continuity of your combination.</li>
  <li>Hack at or sweep his lead leg regularly to prevent it stopping your assault.</li>
  <li>Clear all obstructions as they occur, use isolation whenever possible, because the same obstruction will not therefore twice.</li>
</ul>
<h3 id="4-triple-striking">[4]   Triple Striking</h3>
<p>Used mainly against a tired or offset opponent, sometimes after a distraction or whilst your adversary is in pain. The technique; e.g. punch to head with the lead hand, then the second blow is with your rear hand and directed towards your opponents elbow /forearm (to inflict punishment) the third blow is again with the lead hand and since you have now effectively stopped your opponent from blocking / parrying your assault (by striking his lead arm as he lifts it to block you) then commit your shoulder using say, fingers or one knuckle into the same area as your first strike.</p>
<p>Then disengage and try another angle - this technique is particularly useful against a nervous opponent.</p>
<p><strong>N.B.</strong> Against a nervous opponent, firstly feint a hand blow then follow with a step through low kick.</p>
<p>(Remember he will jump away from your initial attack - so don’t use a kick first as he will then be too far away)</p>
<h3 id="5-the-feint">[5] The Feint</h3>
<p>The purpose of the feint is to draw your opponent’s guard one way whilst striking into the other.</p>
<p>Ideally your opponents lead hand/elbows is in a mid position i.e. it is neither committed to a high low direction with the object of protecting a specific area -  then you should draw your opponents guard downward, whilst striking the high line - this is because upward movement is the slowest of all. But either way - if you feint high or low , always strike into the other sector - alternatively you can also, having feinted and gotten a positive reaction from your opponent, either strike his lead arm or trap it. The first strike must be thrown at speed -but not your fastest blow - there is no strength in the strike - you should attack an automatic defense area(groin) for instance, the strike must be close, so as to be believable. The second strike must be damaging as possible - so as to impress on you adversary, your strength and power - to this end you would use fang yen  one knuckle or straight finger strikes - always use a disengagement as your third blow in case your first is unsuccessful.</p>
<h3 id="6-initiating-a-fracas">[6] Initiating a Fracas</h3>
<ul>
  <li>Use your fastest blow to begin with-and draw a reaction.</li>
  <li>Use only high /low combinations, in order to split his defenses.</li>
  <li>After one or two successful hits, reposition - change your angle of attack.</li>
  <li>Always be ready to step through&#x27;</li>
  <li>Do not strike at your opponent initially, as this draws a reaction. Instead strike at a body tool (to slow his possible response)</li>
  <li>Always strike your opponents arm prior to taking him down.</li>
  <li>Always disengage from a grounded opponent by stamping on his ankle (to prevent him getting up or continuing).</li>
  <li>No technique is initially prohibited, as you do not know your opponent, therefore you cannot anticipate his movement, ergo, no mercy.</li>
  <li>If he moves fast, then use finger, one knuckle etc, as these techniques do not need power to inflict punishment.</li>
  <li>Never use turning kicks etc on an unknown opponent. Never but never turn your back, its folly.</li>
  <li>If he’s larger then you should consider interfering with his breathing at some time.</li>
</ul>
<p>This is excellent for slowing his performance and robbing his strength.</p>
<ul>
  <li>Also if he’s bigger use elbows to his advanced body parts.</li>
  <li>For faster kicks use ball of the foot, heel of the foot for more power.</li>
  <li>Against smaller opponents, hit their legs first, to hinder their mobility. That way they are easier to hit.</li>
  <li>Disengage from a grappler by striking repeatedly at his arms, if caught in a clinch</li>
</ul>
<p>- Take his eyes.</p>
<p>- Take out at least one arm and leg before throwing or   tripping.</p>
<h3 id="7-striking-the-eyes">[7] Striking the Eyes</h3>
<ul>
  <li>Legally a minefield (must be justifiable).</li>
  <li>Least damage, tears, rapid blinking (momentary blindness), confusion.</li>
  <li>Changes your opponent’s prerogatives.</li>
  <li>Misdirection of directive.</li>
  <li>Pain interferes with normal motor functions.</li>
  <li>Too much pain brings fight to a conclusion.</li>
  <li>Failure to make contact still makes for success - as your opponent will break contact or hesitate.</li>
  <li>To prevent advance and retreat motions</li>
</ul>
<h3 id="8-ground-fighting-closed-door">[8] Ground Fighting (closed door)</h3>
<p>Ground fighting is referred to as “<em>closed door</em>” -- due to the fact that there is no room for tactics or maneuvering - no retreat or circling etc... There is no way out - hence “closed door”. When you go to ground (fighting) weather by your choice or your opponents - the idea is that you get the fight over with as soon as possible. Immediate would be a better word. So you select your most violent technique - go berserk- end the fracas, and as importantly all possible reprisals as well.</p>
<p>When your opponents about to strike; he’s on the balls of he’s feet, or he&#x27;s leaning toward you. IT MUST BE UNDERSTOOD at this point he intends to attack. With this in mind it’s vital to move first, in order to gain the upper hand.</p>
<ul>
  <li>Use a blow which turns your adversary or knocks him backwards as this will delay his intent. It causes a pause in his movements, allowing you to direct your attack.</li>
  <li>Use pain for the same purpose as above.</li>
  <li>Eye and nose strikes must also have been considered as he cannot hit what he can’t see - HAVE NO MERCY.</li>
</ul>
<h3 id="9-basic-attacks">[9] Basic attacks</h3>
<ul>
  <li>Disguise your stepping with a hand technique.</li>
  <li>Hit him twice - disengage- break your angle - re-engage. DO NOT get trapped into following your opponent if he retreats.</li>
  <li>REMEMBER if he’s pushed back by your kick - don’t watch his trajectory. Don’t wait, attack low as you haven&#x27;t hit him hard enough.</li>
  <li>If you down your adversary don’t attempt to stamp him immediately (only do so if he’s face down) stamp on the nearest leg (ankle/knee etc...)</li>
  <li>If you kick low for instance and he shows pain - then repeat the performance.</li>
  <li>In combination with kicking - you use hand attacks to your opponents groin, eyes and nose. Because this blinds him and what he doesn’t se he can’t block.</li>
  <li>No matter how obvious the target is until you have secured an advanced line - do not be tempted.</li>
  <li>If your opponent turns away from your attack - hit his calves and knees.</li>
  <li>Whenever possible move yourself in the direction of your kick.</li>
  <li>If your adversary attempts to breach your defenses use your elbows and knees coupled with finger strikes to discourage him.</li>
  <li>Always drill for rearward movement and side ward (offside) as well as progressive.</li>
  <li>Try not to open with a kick, because if you miss, he’s forewarned of your intention and your skill - instead ideally push or strikes him rear wards, then kick as he’s moving away - his legs are thus occupies and incapable of dealing with a low kick.</li>
  <li>Hit and trap - trap and hit - hit- trap - hit - trap - hit - trap. Fight Safe.</li>
</ul>
<h3 id="10-untitled">[10] (Untitled)</h3>
<ul>
  <li>Only after repeated successful hits on your adversary should you attempt a take down or throw.</li>
  <li>One knuckle and feng-yen on a larger opponent.</li>
  <li>Jump attacks only after a successful low attack on the leg (s)</li>
  <li>Don’t trade blows with your opponent - instead take out his attacking body - tool.</li>
  <li>Nothing fancy - keep it simple STUPID . . . . .</li>
</ul>
<h3 id="11-defensive-strategy">[11] Defensive Strategy</h3>
<ul>
  <li>There is no defensive deployment as it removes the mental initiation and replaces it with mental anticipation or reaction. First mind opens you to the total stimulus of combat, second mind only to the reaction to a given stimulus.</li>
  <li>Elbows and joint strikes in order to disable the range of motion of your opponent.</li>
  <li>Pushing and shoving to unbalance your opponent.</li>
  <li>Exclusive use of straight - fingers and one - knuckle blows to discourage offences and curtail certain angles of attack.</li>
</ul>
<h3 id="12-foot-sweeps">[12] Foot Sweeps</h3>
<p>Prior to engaging with the foot sweep,</p>
<p>A)  Push or unbalance</p>
<p>B)  Try to disable his lead arm</p>
<p>C)  If possible try to divert his attention i.e. strike t his nose or eyes</p>
<p>D)  Try an immobilisation prior to the sweep (a grip or seizure)</p>
<p>E)  As a prelude kick to his lead leg or knee his thigh - he will fall quicker and be least inclined to stand up afterward</p>
<p>F)  Remember the main purpose of the foot sweep - is to knock aside the lead leg and expose the rear weight bearing leg - o kick it if possible</p>
<p>G)  Use other low kick combinations with the sweep</p>
<h3 id="13-low-kicks">[13] Low Kicks</h3>
<ul>
  <li>Low kicks are an easy and energy saving technique used singularly or in combination. They are impossible to block or avoid.</li>
  <li>For their disabling ability - to control or limit hi footwork.</li>
  <li>To slow or halt a faster or lighter opponent.</li>
  <li>On a slippery surface.</li>
  <li>In a combination of attacks.</li>
  <li>Do not employ feints with these; be direct and to the point.</li>
  <li>Try and impact with different parts of your foot - so he cannot get the range of your assault.</li>
  <li>If he falls to the ground - stamp on his ankles / calves and knees.</li>
  <li>To prevent his advance / retreat.</li>
</ul>
<h3 id="14-when-not-to-kick">[14] When Not to Kick</h3>
<p><strong>*</strong> Don’t start a fight or respond as a defense with a kick ever.</p>
<p><strong>*</strong> Whenever possible finish your combination with a kick.</p>
<p><strong>*</strong> Never do 2 step-through (kicks) in a row or in a straight line.</p>
<p><strong>*</strong> Only snap when using the balls of the foot - thrust and drive with all other striking   parts.</p>
<p><strong>*</strong> Whenever possible disguise your kicks.</p>
<p><strong>*</strong> Jump - kicks only follow a hard - strike or to bridge a gap.</p>
<p><strong>*</strong> Don’t kick any of your opponents on his rear leg.</p>
<p><strong>*</strong> Look for your opponents lean (bend) prior to kicking - Never kick and upright opponent.</p>
<h3 id="15-when-not-to-grapple">[15] When not to Grapple</h3>
<ul>
  <li>When fighting several adversaries.</li>
  <li>When your opponent is heavier than you.</li>
  <li>Not until you have disabled at least one arm of his.</li>
  <li>Remember, it’s better to use all your strength against one point - than use it against all available points.</li>
  <li>Most grapples are won by thumbs.</li>
  <li>Pain delays reaction - constructive defense and strategy.</li>
  <li>It’s too late to discover your opponent’s weaknesses on the ground.</li>
  <li>Don’t use holds, your fighting the wrong fight</li>
  <li>Try to be last on the ground.</li>
</ul>
<h3 id="16-close-quarter">[16] Close Quarter</h3>
<ul>
  <li>Use clawing and gripping to limit your opponent’s range of movement.</li>
  <li>Catch and seize areas around the neck in order to achieve dominance.</li>
  <li>If he’s kicking (knees, shins etc...) seize his belly to prevent this.</li>
  <li>Snap fingers and thumbs.</li>
  <li>DON’T use locks . . .</li>
  <li>If he’s attempting to head - butt, eyes and mouth are the main targets.</li>
  <li>The shoulders of your opponent are the prime target - no arms.</li>
  <li>Thumbs and fingers win the day.</li>
  <li>One knuckle of course.</li>
  <li>Hit and trap (immobilize)</li>
  <li>Push high - hit low.</li>
</ul>
<h3 id="17-straight-fingers">[17] Straight Fingers</h3>
<ul>
  <li>Initial long range striking implement of contacting soft targets and nerve centre’s - using speed and NO STRENGTH.</li>
  <li>Flicking and rapid stabbing motions ONLY - First line of offence / defense.</li>
  <li>All techniques are based on combinations that revolve around straight fingers.</li>
  <li>The serious martial artist has a large amount of straight finger techniques.</li>
  <li>After one or two successful strikes with straight fingers - one knuckle or a low kick is just dandy.</li>
  <li>Keep the lead arm loose for techniques which can swap or change from straight fingers.</li>
</ul>
<h3 id="18-heel-of-the-foot-kicking">[18] Heel of the Foot Kicking</h3>
<ul>
  <li>Stun ability for large muscle groups.</li>
  <li>Jamming and stopping power from a stable base.</li>
  <li>First and longest interception of your opponent’s movement.</li>
  <li>Useful check on your opponent’s movement. Good limiting capability of your opponent range of maneuverability.</li>
  <li>Ideal after a push as a low check to your opponents lead leg in order to hinder his movement.</li>
  <li>Good first hit in combination with low kick (s)</li>
  <li>Useful joint attacking tool aided with a stamp as follow up.</li>
  <li>Never use a second heel of the foot kick after a successful first.</li>
</ul>
<h3 id="19-ball-of-the-foot-kicking">[19] Ball of the Foot Kicking</h3>
<ul>
  <li>Long - range interception usually followed up by a second long - range attack</li>
  <li>Only used with a snap or whipping action - no attempt to instill strength - speed only.</li>
  <li>Try and hit bony areas or thinly muscled areas in order to enhance impact.</li>
  <li>Never hit into dense muscled areas due to the rapid impact of the kick, muscles and cavities absorb impact easily - so if you hit one of these areas with the ball or toes of the foot, then be ready with an immediate follow up.</li>
  <li>Useful with a hand combination.</li>
</ul>
<h3 id="20-trips-and-take-downs">[20] Trips and Take Downs</h3>
<p>Trips unless you’re injured are a No No.</p>
<ul>
  <li>If fighting a friend or acquaintance who is drunk.</li>
  <li>Against someone who is inferior i.e. younger, not as experienced - (to whom you can afford to be merciful).</li>
  <li>If you are on a slippery or limited surface.</li>
  <li>If on a rolling or moving surface (boat etc . . .)</li>
  <li>Never in a gang attack (several opponents)</li>
  <li>Only possible if your eyes are damaged and have to ‘feel’ your opponent.</li>
  <li>Against an uneven surface - where it’s possible to do your opponent more harm</li>
</ul>
<h3 id="21-short-range-low-kicking">[21] Short Range Low - Kicking</h3>
<ul>
  <li>Alternate long and close range with intermittent pushing to clear a range.</li>
  <li>Regular joint hitting with large muscle striking included in combination.</li>
  <li>Includes knee strikes as well in order to bring a strong weapon to bear.</li>
  <li>Use elbow to clear upper body distance.</li>
  <li>Remember to change your direction every 2 to 3 hits in order to prevent an interception or blockage to your line of offence.</li>
  <li>Alternate between snap and swing - kicks snap when he’s close and swing as he gains distance.</li>
  <li>To prevent his advance / retreat.</li>
</ul>
<h3 id="22-elbow-and-forearm">[22] Elbow and Forearm</h3>
<ul>
  <li>Used primarily to create distance giving you more room to maneuver.</li>
  <li>Used into the lead arm or shoulder of your opponent.</li>
  <li>Elbow and push. Close and elbow.</li>
  <li>Trap and forearm etc . . . .</li>
  <li>In combination with low kicks.</li>
  <li>Claw and elbows / forearm.</li>
  <li>Thump large muscle groups then claw above your elbow target, to enhance pain.</li>
  <li>Always elbow the neck never the head - the head moves the neck doesn’t.</li>
  <li>If he turns his back to your initial assault; then hit downwards as close to his hips as possible.</li>
</ul>
<h3 id="23-one-knuckle-punches">[23] One Knuckle Punches</h3>
<ul>
  <li>First knuckle is used to lightly muscled areas and areas with little protection bone, muscle or otherwise - Second knuckle is used into more densely muscled and boned areas/ harder to hit stronger areas.</li>
  <li>As a respect getter.</li>
  <li>As an aid to downing a larger opponent.</li>
  <li>In use with traps as a blinder in order to limit your opponents options.</li>
  <li>To isolate any muscle group in order to limit your opponents response.</li>
  <li>To cause confusion through&#x27; pain or as a distraction.</li>
</ul>
<h3 id="24-feng-yen">[24] Feng - Yen</h3>
<ul>
  <li>Main weapon is muscle isolation generally hitting downwards to provide nerve shock.</li>
  <li>Ideal for striking the centre of the chest - to isolate both arms momentarily.</li>
  <li>Used as a stop - hit to your opponents ribcage.</li>
  <li>Used with traps to isolate the arm.</li>
  <li>Above or below the eye or the bridge of the nose - as a blinder.</li>
  <li>Into weaker and softer areas so as to inflict maximum pain.</li>
  <li>Against the vertebrae as a crippling technique or temporary paralysis.</li>
</ul>
<h3 id="25-circular-technique">[25] Circular Technique</h3>
<ul>
  <li>There is little use in Ming - Chuan for circular techniques. They do serve to confuse your opponent but the time used to perform them negates their use.</li>
  <li>Oppose your opponents force at his weakest point (Chiun). He said that misdirecting his force was pointless as it did not achieve a direct objective.</li>
  <li>Against multiple attacks, is dangerous.</li>
  <li>The shortest distance between two points is a straight line.</li>
  <li>Keep in mind that survival is utmost in your mind and circular techniques take more time - Any longer than 3 - 5 seconds?</li>
</ul>
<h3 id="26-hand-and-foot-attacks-combinations">[26] Hand and Foot Attacks (combinations)</h3>
<ul>
  <li>The use of hand and foot against an experienced opponent is only effective if you hit high / low or low / high combinations.</li>
  <li>Never hit at the same height with both and hand foot as you risk the chance of parrying yourself. Besides which it allows your opponent the advantage of weaving back (leaning) when you should be seeking to offset his leg maneuverability.</li>
  <li>In any fight think leg, leg i.e. stop your opponent’s maneuverability; limit his range of movements - crippling his chance of keeping up with you. Stop him from moving around you.</li>
</ul>
<p><strong>a)</strong> “<em>A still target is easier to hit</em>”-Chiun.</p>
<p><strong>b)</strong> “<em>Moving around uses valuable energy</em>” -Mirakami.</p>
<p><strong>c)</strong> “<em>Work on keeping your opponent as still as possible</em>” -Chiun.</p>
<p><strong>d)</strong> “<em>First priority - stop him - then take him out</em>” -Grandmaster Lew.</p>
<p><strong>e)</strong> “<em>An army marches on its feet</em>” -Sun Tzu.</p>
<p><strong>f)</strong> “<em>Cut down the flag - pole to stop the flag flying</em>” -Chuin.</p>
<p><strong>g)</strong> “Push high - kick low - again and again it’s easier and safer” -John Yee.</p>
<p><strong>H)</strong>”<em>Kill the legs to stop the body</em>&quot; -Chuin.</p>
<p><strong>I)</strong> “<em>Hit the legs to stop his advance / retreat</em>”</p>
<h3 id="27-stamping-knee-shin-ankle-instep-etc">[27] Stamping - KNEE, SHIN, ANKLE, INSTEP etc...</h3>
<p><strong>*</strong> Natural finisher to low attack.</p>
<p><strong>*</strong> Attempting to prevent a counter or a response after an attack.</p>
<p><strong>*</strong> Attempting to inflict maximum pain.</p>
<p><strong>*</strong> Trying to disable or stun large muscle groups.</p>
<p><strong>*</strong> Hitting your opponent’s favourite kicking leg.</p>
<p><strong>*</strong> Prevents advance or retreat by him.</p>
<p><strong>*</strong> Good stop – hit.</p>
<p><strong>*</strong> Good finisher to a prone opponent.</p>
<p><strong>*</strong> Having first angled his leg, it’s easier damaged or broken.</p>
<p><strong>*</strong> Insures difficulty for your opponent continuing the fight.</p>
<p><strong>*</strong> Ideal for stamping on the Achilles tendon of a kneeling opponent.</p>
<p><strong>*</strong> Works well in conjunction with an axe kick.</p>
<p><strong>*</strong> Excellent opener for a trip/throw.</p>
<p><strong>*</strong> The foot sweep being a natural follow – up.</p>
<p><strong>*</strong> The most natural close range kick.</p>
<p><strong>*</strong> If possible push first.</p>
<p><strong>*</strong> Excellent follow to a kick slap – down.</p>
<p><strong>*</strong> Perfect answer to a committed opponent.</p>
<h3 id="28-nerve-grabbing">[28] Nerve Grabbing</h3>
<p><strong>#</strong> As a painful distraction whilst you grab or hit a more lethal point</p>
<p><strong>#</strong> To prevent your attacking hand/tool being blocked</p>
<p><strong>#</strong> To make your opponent drop a weapon</p>
<p><strong>#</strong> As a deterrent to a further fracas</p>
<p><strong>#</strong> To control your opponent’s range of movement</p>
<p><strong>#</strong> To deter your adversary from stepping - to gain or lose ground</p>
<p><strong>#</strong> Aids your striking skills as the grab holds your opponent steady by rooting him to the spot</p>
<p><strong>#</strong> Buys time for a strike</p>
<p><strong>#</strong> Prior to a trip or throw to insure your opponent’s compliance</p>
<p><strong>#</strong> To isolate a particular muscle group</p>
<p><strong>#</strong> To expose hither to concealed pressure points</p>
<p><strong>#</strong> As a bargaining tool, to convince an opponent to desist from further aggression</p>
<p><strong>#</strong> Used to create a space in order to bring a more powerful weapon to bear</p>
<p><strong>#</strong> To sensitise a particular muscle group prior to a further attack, thereby making it a more painful assault</p>
<h3 id="29-hitting-the-thigh">[29] Hitting the Thigh</h3>
<ul>
  <li>To narrow your opponent’s range of movement</li>
  <li>To interrupt his rhythm</li>
  <li>To prevent his chasing you - should you wish to retreat</li>
  <li>To render him still, for a more devastating attack</li>
  <li>In combination with low - kicks</li>
  <li>Prior to a jump hand/foot assault</li>
  <li>As an entry to sweeps</li>
  <li>As a painful deterrent</li>
  <li>As disengagement</li>
  <li>To prevent your opponent kicking</li>
  <li>To anchor his leg to the ground for the purpose of attacking it</li>
  <li>If you have committed yourself to a trap you have missed</li>
  <li>To slow an opponent, if he has better footwork</li>
  <li>Prior to attacking hi rear leg</li>
  <li>To gain time ( breathing space )</li>
</ul>
<h3 id="30-shoving">[30] Shoving</h3>
<ul>
  <li>To disturb a combination.</li>
  <li>In combination with a low kick - in order to prevent his kicking as a response.</li>
  <li>To prevent jump attacks.</li>
  <li>To offset him prior to your jump attack.</li>
  <li>To gain time against a wall or such prior to a powerful attack.</li>
  <li>Used prior to a step through&#x27; kick.</li>
  <li>Used as an attempt to prejudge distance i.e. to set him up for a serious injury by predetermining his positioning.</li>
  <li>Used prior to ground fighting.</li>
</ul>
<h3 id="31-single-arm-push">[31] Single Arm Push</h3>
<ol class="numbered">
  <li>To cause a pause in his recovery time - to offset his movement.</li>
  <li>To gain proper distance against a close opponent.</li>
  <li>To put his weight on his rear leg, which makes it difficult to absorb punishment.</li>
  <li>Used to predetermine range.</li>
  <li>To prevent him dodging your assault.</li>
  <li>Used in conjunction with sweeps.</li>
  <li>Prior to a jump hand attack.</li>
</ol>
<h3 id="32-superior-distance">[32] Superior Distance</h3>
<ul>
  <li>In Ming-Ch&#x27;uan your distance is determined by your opponent’s lead leg / arm as these are your primary targets. Once hit successfully, it prevents any counter or blocking by him.</li>
  <li>Your adversary has to take a step in order to bring you into striking effect; he is already inside your perimeter.</li>
  <li>Superior distance allows you to easily anticipate his angles of attack, and allows you the luxury of off-siding him at every opportunity.</li>
  <li>It also allows you a larger variety (scope) of attack.</li>
  <li>It leaves room for jump kicks, which most styles don&#x27;t have.</li>
  <li>Step through&#x27; kicks catch up with a retreating opponent.</li>
  <li>Allows you to stop - kick effectively.</li>
  <li>Enhances your analysis ability.</li>
  <li>Also allows more peripheral vision. Anticipation of oblique techniques.</li>
  <li>Changing initiation mid point is also not a problem.</li>
</ul>
<h3 id="33-jump-axe-kick">[33] Jump Axe Kick</h3>
<ul>
  <li>In anticipation of his doubling up.</li>
  <li>In combination with a low kick.</li>
  <li>With a sweep.</li>
  <li>With a push.</li>
  <li>After a groin slap.</li>
  <li>In combination with a groin slap.</li>
  <li>In combination with a punch to the thigh.</li>
  <li>As a natural finisher after a reverse roundhouse.</li>
  <li>Having grabbed a kicking leg, in order to prevent a hand attack by an already trapped opponent.</li>
  <li>Against a lean-backer.</li>
  <li>With a trap, if he starts to duck.</li>
</ul>
<h3 id="34-fitness">[34] FITNESS</h3>
<ul>
  <li>Faster recovery.</li>
  <li>Better accuracy - the fitter, the more accurate the 20th or 30th blow.</li>
  <li>Better reflexes.</li>
  <li>More awareness.</li>
  <li>Invaluable in a running fracas - run - fight - run - fight     etc...</li>
  <li>Quicker technique.</li>
  <li>Faster initiation speed.</li>
  <li>Faster thinking - analysis - tactics etc...</li>
  <li>Denser muscle - helps to absorb impact.</li>
  <li>More oxygen efficient.</li>
  <li>Better control over nerves (fight related).</li>
  <li>More confidence.</li>
</ul>
<h3 id="35-muscle-body-building-weights">[35] Muscle (body building weights)</h3>
<ol class="numbered">
  <li>Better grappling.</li>
  <li>Stronger holds.</li>
  <li>Better impact resistance.</li>
  <li>More muscle control during technique.</li>
  <li>Better penetration on most technique.</li>
  <li>Makes technique harder to block.</li>
  <li>Faster withdrawal after technique thrown, (involves muscle                                      contraction).</li>
  <li>Better pressure on nerve holds.</li>
  <li>Less visible effort for gains.</li>
  <li>Better lung capacity.</li>
  <li>Better breath control.</li>
  <li>Less exertion in a fight.</li>
  <li>Better mass control.</li>
  <li>Faster initial movement.</li>
</ol>
<h3 id="36-close-range-openers">[36] Close Range Openers</h3>
<ul>
  <li>Natural stance - trap or press the arm and elbow - the shoulder - biceps - <strong>brachialis</strong> - triceps - high point on fore arm etc...</li>
  <li>*Natural stance - knee inside his lead leg then knee his other thigh.</li>
</ul>
<p>Or in combination with first strike swing R/House his other leg front kick his groin - R/House his inside knee - trap his arm and use above elbows etc...</p>
<p>Close range openers must be short and sweet using your most powerful strikes as a weaker strike will allow him to retaliate.</p>
<p>“<em>A good opener is a good finisher</em>” -Chiun</p>
<h3 id="37-controlling">[37] Controlling</h3>
<p>There are essentially only two things you can do with an opponent control him or kill him. We are dealing with control as most people are unwilling to murder their adversary. Pain is the key to control - as it;</p>
<p><strong>1) </strong>Immobilizes him.</p>
<p><strong>2)</strong> Prevents any constructive response from him.</p>
<p><strong>3</strong><strong>)</strong> Isolates major muscle groups depending on area gripped.</p>
<p><strong>4)</strong> Controls your opponents movement by forcing compliance (path of least pain)</p>
<p><strong>5)</strong> Prevents any legwork or kicking by him due to downward pressure.</p>
<h3 id="38-as-a-defence">[38] As A Defence</h3>
<ul>
  <li>When your opponent strikes first;</li>
</ul>
<p><strong>A)</strong>  Strike to his eyes as a primary target - (he can’t hit what he can’t see).</p>
<p><strong>B)</strong>  Strike to his knees (lower legs) next in order to steady him. Once he cannot move (advance) further or see clearly, then you can attack. The first priority is a facial strike. 1) As in A above and 2) for the shock value. If the strike hits all will work, if it doesn’t then there’s every chance of a hesitation by him as he will blink, turn his head - lean back etc, in an attempt to extricate himself from your blow. The leg attack should be short and vicious.</p>
<p>It has several objectives;</p>
<p><strong>a)</strong> To halt all foreword and rearward movement.</p>
<p><strong>b)</strong> To steady him for attack.</p>
<p><strong>c)</strong>  To establish a safe distance.</p>
<p>These rules must be obeyed in this order as it’s essential to stop or delay his aggression, until you can attack.</p>
<p>Keep repeating this procedure until you are successful.</p>
<p>Eyes, legs, eyes, legs.</p>
<h3 id="39-attack-smaller-opponent">[39] Attack (smaller opponent)</h3>
<p>If your opponent’s smaller - then hit his legs - this inhibits his movements, prevents him advancing at you or retreating from you. It also negates him seeking an advantage through positioning - presenting preferred targets etc . . . It also steadies him for you to attack later. Repeated attacks on the same area is a respect getter - it also heightens his pain.</p>
<p>The idea is to prevent him from running rings around you - or to prevent the need to endlessly chase him.</p>
<p>“<em>An army marches on its feet</em>” -Sun Tzu.</p>
<h3 id="40-attack-larger-opponent">[40] Attack (larger opponent)</h3>
<p>If you opponent’s (bigger / heavier):</p>
<ul>
  <li>First hit his arm (s)</li>
</ul>
<p>His advancing - retreating should not hinder you, as being smaller you have greater maneuverability, and be quicker on you feet.</p>
<p>His hands on the contrary are more dangerous than his feet. Keep striking his arm (lead) until it’s close to his body (in order to press or trap) or he changes sides due to the pain in that arm. Pinch, Feng - yen - then elbow in similar combinations - having caused him to back away then attack his legs prior to hitting his body.</p>
<p>In attack, please remember that a single or double strike to the body (his) is a bonus - your primary concern is to prepare a path into and out of his defensive line, without the risk of being hit yourself - therefore if you have time to strike his head or body - good enough but it’s not your primary objective only a secondary target - crippling his lead body parts and preventing a dangerous response is the main concern.</p>
<p>Take your time - if you’ve prepared your task correctly - you can hit to the body without the fear of reprisal.</p>
<h3 id="41-depth-of-impact">[41] Depth of Impact</h3>
<p>This depends on your surrounding environment. For instance - in a large open space; the depth of impact is quite small due to the lack of solid objects nearby - therefore you should be more selective of the targets you choose.</p>
<p>Accuracy is of the utmost importance at the other end of the scale.</p>
<p>In an enclosed space with several solid objects, either cause your opponent to step against a solid object push / shove him against it - then use deep impact to cause maximum damage.</p>
<p>Basically, if your opponent is unsupported he is easily knocked backwards thereby absorbing most of your power, with minimum effect. So by picking non power targets i.e. eyes, throat etc . . . . you can inflict greater damage.</p>
<p>When your opponent is supported by a solid object, he then receives all of your power. Bone breaking is quite possible given this scenario.</p>
<p>Therefore: Hit fast and light when in open spaces.</p>
<p>Push and use power is enclosed spaces.</p>
<h3 id="42-high-kicking-head-etc">[42] High Kicking (head etc)</h3>
<p>Can only be applied when you have first secured the legs of your opponent - a high kick is never attempted on its own - no matter how tempting the target. Target specifics can only be attained after hitting the low line effectively.</p>
<p>You may kick high only when, at least one of your opponent’s hands is on his injured leg. If both hands are on guard or close to guard - then hit his legs again - so as to lower that guard before initiating a high kick. Do not attempt to kick above the belt buckle unless you’ve made a preparation on your opponents lead hand - above his sternum make your preparation on his advanced leg. Repeat these preparations - watching for his reactions - then strike the appropriate area.</p>
<p>Remember one hand of your opponents has to be on or holding his injured leg - that way he only has one hand high to block you - but the other hand can’t counter. If both hands are high then it’s possible to block and counter - more fool you if you allow this. There is no point kicking high if it doesn’t land.</p>
<p>A kick to the head is more valuable than to anywhere on the body.</p>
<h3 id="43-distraction">[43] Distraction</h3>
<ul>
  <li>Drawing your opponent’s attention away from the real threat.</li>
  <li>Slap your chest with your free hand for close quarter.</li>
  <li>Slap your thigh to draw his attention from a high level attack.</li>
  <li>Similar to above - lightly slap your foot on the ground.</li>
  <li>Whilst speaking lower your voice - it draws his hearing - he may even lean forward - then hit.</li>
  <li>Shout and clap your hands - to get a rapid withdrawal or lean back then kick low or step through kick.</li>
  <li>Throw an object (s) into his line of sight, then kick lower.</li>
  <li>Press his arm to his side then elbow his arm (pain is also a distraction).</li>
</ul>
<h3 id="44-entry-and-exit-techniques">[44] Entry and Exit Techniques</h3>
<p>Are usually aimed at your opponents lead extremities and can be used prior to attack and/or disengagement. The entry and exit techniques can also be used as a dissuasion - to discourage your adversary from further punishment.</p>
<p>Also, as a preview of what&#x27;s about to happen to him or as a basic body tool robbing exercise.</p>
<p>The rules of engagement are as follows:</p>
<ul>
  <li>Large muscle groups use your elbows or knees.</li>
  <li>Minor muscle groups use hand blows - smaller hand weapons for greater pain etc...</li>
  <li>Joint attacks use double strikes first blow to weaken and second blow to break or cripple.</li>
</ul>
<p>Always strike the joint at its weakest point - i.e. with no surrounding muscle, only ligaments.</p>
<p>Bone breaking etc is not involved as it requires too much time.</p>
<p>All techniques are aimed at muscles and joints.</p>
<p>All techniques are performed with the lead hand.</p>
<p>Try and strike downward as much as possible as this keeps their leg on the ground or their arm close to their body.</p>
<h3 id="45-interspersed-power">[45] Interspersed Power</h3>
<p>Against almost everyone - varied power hitting is invaluable - this can only be used by an experienced Martial Artist who is very accurate.</p>
<p>For example you would say - back fist your opponents lead hand (light and fast ) with the object of moving it to one side - out of your directional intent. Punch hard to his thigh then lightly straight finger his eye or neck, disengage with a stamp or side kick to his lead leg (power)</p>
<p>This varied light then hard kicking combination dissuades most adversaries. It also has great psychological potential - which psyches out your opponent.</p>
<p>[46] Rear Leg Kicking</p>
<p>Is quite unusual in the Chinese Repertoire due to its cumbersome slowness, true, it has more power but is easily dodged and leads to a ‘baseball like’ over commitment on your behalf. It has few uses but I still list them here:</p>
<ul>
  <li>After you’ve made successful preparation on your lead leg.</li>
  <li>When your opponent is dazed or stunned.</li>
  <li>After a successful leg sweep when your opponent is committed to a general (predictable) direction.</li>
  <li>When your opponent has been doubled up.</li>
  <li>After a pushing / shoving technique when his path is predictable.</li>
  <li>In a jumping maneuver - having first drawn a favourable reaction from him.</li>
  <li>Against a blinder opponent.</li>
</ul>
<p><strong>*******************************************</strong></p>
<p>Only in these situations is rear leg kicking regarded with any favour.</p>
<p>Its disadvantages must also be numbered:</p>
<ul>
  <li>Over commitment of kick leg and body in the event of a miss.</li>
  <li>Too much strength usually employed (sledgehammer to kill mouse)</li>
  <li>Too long a recovery time (phase time)</li>
</ul>
<h3 id="47-conditioning">[47] Conditioning</h3>
<p>Body tool conditioning is highly recommended as it’s of the UTMOST importance to deliver heavy impact continuously to hard body parts (head etc. . .) without injury to yourself.</p>
<p>Brick breaking with all or most body tools is recommended - the law states that you can only use minimum force to defend yourself - i.e. one blow - that blow has to count - hence conditioning.</p>
<p>The amount of conditioning required on the type of adversary of your encounter - i.e. bigger opponent - then finish with your best breaking technique etc .</p>
<h3 id="48-variable-speed">[48] Variable Speed</h3>
<p>It’s suggested that your first move is reserved for the eyes, throat etc, body parts that do not require much penetration.</p>
<p>Techniques that require greater penetration need a slower speed but more power; hence it is a secondary target.</p>
<p>In open spaces - rapid striking is essential - hence your fastest technique. Hold your opponent still with low kick and score with rapid hands.</p>
<p>Strikes to immobilising points are also slower - ideally 2 fast techniques and 1 slower is an ideal combination. Of course if you’re hitting a rapid moving target (hand) then use your fastest move.</p>
<h3 id="49-arm-kicking">[49] Arm Kicking</h3>
<p>Is a great dissuader, as it delivers heavy punishment to your opponents lead arm.</p>
<p>Usually you trap/strike (hand) then kick having slowed his arm.</p>
<p>Or hit his arm with your hand - then trap and kick (faster opponent)</p>
<p>Against and lean - backer who&#x27;s arm goes out of reach. Attack his leg or mid - section then use the above to cripple his arm.</p>
<p>After a successful entry and having struck your opponent - kick his arm in order to secure a second breach of his defensive perimeter.</p>
<p>“On entry secure your perimeter, on exit secure your perimeter”.</p>
<h3 id="50-securing-your-perimeter">[50] Securing Your Perimeter</h3>
<p>Involves immobilising your opponent’s defensive perimeter (line of offence / defence).</p>
<p>There are several ways to do this and all are used in combination with each other;</p>
<ul>
  <li>Trap</li>
  <li>Strike (with a view to immobilise)</li>
  <li>Claw</li>
</ul>
<p>It must be said - that if you feel any continuing tension or resistance in your opponents lead arm - then continue with the above methods until his lead arm is slack or he is incapable of holding it up - it’s now safe to enter or withdraw.</p>
<h3 id="51-in-analysis">[51] In Analysis</h3>
<p>The first thing to observe after you have successfully withdrawn a safe distance is:</p>
<p>Is there obvious damage to his lead arm - slack - unable to hold up his guard etc. . .</p>
<p>Is his lead leg damaged - all his weight on or off it, does he seem dazed - confused - if so - is he looking at you - if he is - then he’s faking . Does he have visual problems? If all the above seem favourable then it’s safe to re - enter - attacking the most damaged body part, insuring his continued compliance with your attack.</p>
<h3 id="52-slowing-your-opponent">[52] Slowing your Opponent</h3>
<p>With a view to getting a breather:</p>
<p>For use when your tired or against a friendly opponent.</p>
<p>Foot sweep or take downs so as to facilitate a breather as your opponent gains an upright posture. Claw a large muscle group so as to momentarily freeze your opponent - gaining you a short respite.</p>
<p>Attacking a joint in a single or combination - again with the same result</p>
<p>Striking the eyes or nose - for a similar result</p>
<p>All the above used singularly or in combination acquire the desired result</p>
<p>Study methods of slowing your adversary - in order to deal with potentially faster opponent, or to get a breather</p>
<p>The object is not to terminate the encounter only to delay it. When you come across a superior fighter - it’s this change of tactic that can lead to a positive conclusion.</p>
<p>To further delay his attraction, on throwing - throw him on uneven ground - edge of pavement etc, in order to increase the damage to him thereby delaying him even further</p>
<p>On clawing; claw in combination - same purpose.</p>
<p>On joint attacking - stamp after a successful joint attack.</p>
<h3 id="53-important-points-to-watch">[53] Important Points to Watch</h3>
<p>Problems and answers,</p>
<ul>
  <li>You’ve hit your opponents lead arm and he doesn’t seem affected</li>
</ul>
<p><em><strong>A</strong></em>  Double up on strikes to arm - one fast and then the other heavy</p>
<ul>
  <li>You’ve hit your adversary and he moves backwards</li>
</ul>
<p><em><strong>A</strong></em>  Immediately launch a low attack on his legs - he should have fallen down on your blow - if anything else happens then he wasn’t hit hard enough</p>
<ul>
  <li>You’ve kicked him mid - section or chest and he hasn’t reacted</li>
</ul>
<p><em><strong>A</strong></em>  Leg sweep or attack legs on retreat analyse then attack again</p>
<ul>
  <li>You’ve struck at his eyes and he’s flinched - drawn his head away</li>
</ul>
<p><em><strong>A</strong></em>  Immediately re - attack a lower target - throat, carotid artery etc . . . Whilst kneeing the thigh, so as to steady him to prevent the same situation happening again</p>
<ul>
  <li>You’ve attempted a trap and failed due to missing his hand</li>
</ul>
<p><em><strong>A</strong></em>  Attack his legs to prevent his advance or withdrawal then hit the arm prior to trapping as this slows his arm and makes it easier to catch</p>
<ul>
  <li>You’ve kicked at his leg and missed due to his withdrawal or him lifting his leg</li>
</ul>
<p><em><strong>A</strong></em>  Your leg has to be half extended on impact - step through and try again and if he lifts his leg to escape punishment kick his thigh as he can’t move much</p>
<ul>
  <li>You’ve hit - he’s ducked</li>
</ul>
<p><em><strong>A</strong></em>  Double up on strike - same time hit high - kick low - you’ll catch his leg as he ducks.</p>
<ul>
  <li>You’ve hit - he’s withdrawing faster</li>
</ul>
<p><em><strong>A</strong></em>  Rush forward attacking his arm then jump hand attack to catch up. Low kick after to slow him down.</p>
<ul>
  <li>You’ve hit - he’s advanced</li>
</ul>
<p><em><strong>A</strong></em>  Side step - attack his legs, to prevent this - then re attack or just shove when he’s slowed down.</p>
<ul>
  <li>If you’ve swept and he hasn’t fallen</li>
</ul>
<p><em><strong>A</strong></em>  Sweep again then use destructive kicks to his leg - sometimes a single sweep is not enough on its own</p>
<h3 id="54-destructive-kicks">[54] Destructive Kicks</h3>
<p>He front kicks - kick up under his leg. Lean back to do so - thereby putting your body out of his reach.</p>
<p>He roundhouses - front kick upwards under his leg to connect between his knee to his hip. Alternatively block and kick his groin or standing leg. Or raise your lead kick under his shin / knee</p>
<p>He side - kicks - same as front kick</p>
<p>He uses turning kick - either, flat foot stamp on his kicking leg buttock or block and front kick his kick leg between leg and groin</p>
<p>Use elbow and knees also as destructive defence - the idea is to discourage a repeat of this technique</p>
<p>[55] (Untitled)</p>
<p>Jump kicks are best used after slapping down successfully a kick by your opponent</p>
<p>If you’ve made a prior application on your opponents lead leg</p>
<p>To catch up on a fast withdrawing opponent in order to bridge the gap</p>
<p>In combination with a foot sweep</p>
<p>After a successful mid - section kick which causes him to bend - over, thereby preventing any kicking by him</p>
<p>After a successful push - as he attempts to regain balance</p>
<p>As a defensive tactic against an advancing opponent - thereby preventing or discouraging a continued assault</p>
<h3 id="56-leg-destruction">[56] Leg Destruction</h3>
<p>All leg destruction combinations should be a combined joint and major leg muscle attack. Lower leg attacks cause potential dysfunction but do not immobilize the legs completely. If it is not possible to damage the lead leg then you must deflect that leg or bend it so as to keep his body weight on that leg - if shoving your opponent backwards and he is a good kicker, keep a low guard with your rear hand in case he kicks as the weight comes off his lead foot.</p>
<p>Do not attempt to break the leg just punish it in an ever ascending scale. Eventually the leg will be better supported and then easily broken - be cautious of what you’re attempting to achieve. If he wants to raise his leg then concentrate on kicking the dorsal muscle of the thigh as only this muscle lifts the leg.</p>
<p>Penetrate 2 or 3 inches into the leg muscle and even deeper into the joint as the joint has more give in it. Attempt to numb rather than crush.</p>
<p>The object is to make him limp prior to destroying his leg altogether.</p>
<h3 id="57-destruction-of-the-lead-arm">[57] Destruction of the Lead Arm</h3>
<p>Accomplished in a similar way as to the leg;</p>
<p>Firstly strike a minor muscle to slow or lightly damage the lead arm. Then attempt a strike to a larger muscle - i.e. biceps, triceps, shoulder or forearm etc. The traps are also a target as is the clavicle. You can use a minor muscle, larger muscle then minor muscle, - but like this - you must not strike two minor or two major in sequence unless you’re targeting lower arm and upper arm together.</p>
<h3 id="58-single-knuckle">[58] Single Knuckle</h3>
<p>One knuckle attacks are the fastest in your repertoire, and are useful providing you concentrate on accuracy</p>
<p>The main targets are the body protrusions eyebrows - below eyes - bridge of nose - point of chin - jaw hinge - temples etc.</p>
<p>This is almost inexhaustible as there is no applied strength, just a slight downward motion on impact. Your main target are the eyes so as to interfere with his vision. Used in conjunction with elbow this is a formidable weapon. The rapid striking is compared to a ‘<em>woodpecker</em>’.</p>
<h3 id="59-hitting-the-mid-section">[59] Hitting the Mid - Section</h3>
<p>Is only useful to ‘double - up’ your opponent thereby keeping your opponents legs momentarily still. This enables you to attack his legs without hindrance</p>
<p>When hitting the untrained it also serves to ‘wind’ your opponent, thereby robbing him of energy. Mid-section hitting is also valuable in that it exposes his ‘off - side’ (back). The neck is a good target when thus exposed.</p>
<p>After a successful strike to the mid - section a jump kick is also high on your list</p>
<p>But be warned - do not use too much strength hitting this area as you are exposed.</p>
<h3 id="60-liver-hitting">[60] Liver Hitting</h3>
<p>Is the most performed on the body as unlike stomach or sternum strikes the liver hit is the best bet as the is no quick recovery - use middle knuckle or thumb. The liver strike robs you of all energy. A medium blow will bring your opponent to his knees but a heavy blow will kill- especially after he’s eaten or drunk alcohol... The major fact that makes this area a priority target is that it is so disabling. It makes no difference if it&#x27;s hit straight or from the sides.</p>
<h3 id="61-kidney-hitting">[61] Kidney Hitting</h3>
<p>Is second only to the liver for its long lasting effect - hit quickly downwards it robs the legs of energy thus downing your opponent - where a stamp on the ankles will render the fracas over. Again a medium blow will work, a heavy blow can kill through renal failure.</p>
<p>The blow is very painful and takes a long time to recover.</p>
<p>It has an added psychological bonus in that your opponent urinates blood for several days after - therefore he is unlikely to attempt to fight you again.</p>
<h3 id="62-carotid-artery-hitting">[62] Carotid Artery Hitting</h3>
<p>Is a very serious technique and only to be used in multiple attack or weapon attack - there are also two acupuncture points which are lethal when struck and are also located next to the carotid artery.</p>
<p>Basically the brain is deprived of blood (oxygen) when this point is hit and your blood pressure also hits basement leading to fainting attacks and dizziness long after this area has been hit. It’s an excellent system to hit due to the fact that it derives such punishment. Regardless of size this target provides excellent results.</p>
<h3 id="63-elbows">[63] Elbows</h3>
<p>Elbows are the most painful hand weapons in your arsenal. Used in the isolation of body tools or in final phase of fracas.</p>
<p>The elbow is a serious tool in any fight -   it should be readily used - its basic range is as a close-in weapon. Striking the soft parts of the body, it causes temporary disruption and is rarely fatal on its own.</p>
<p>Used against firm body parts- head, neck, collar bones etc...It causes serious damage. If you wish to cause further damage then double up on the elbows into the same target area.</p>
<p>Elbows also have a use in joint attacks and are also excellent at large muscle destruction.</p>
<p>Elbow then push you opponent into kicking range.</p>
<p>Elbows are used in combination with knees usually.</p>
<p>There should be no tension in elbow strikes - only speed. Hit as often and as fast as you can. The elbow will do the rest.</p>
<p>Prime targets are the eye sockets, temple, neck, heart etc...</p>
<p>Secondary targets are ribs, spine, sternum, face etc...</p>
<p>Use traps whenever possible with the elbows.</p>
<h3 id="64-turning-and-jump-turning-kicks">[64] Turning and Jump Turning Kicks</h3>
<p>The use of the above is used to bring more power to a targeted area and also a degree of unpredictability. These off angle attacks offer a degree of opportunity when a more direct attack is easily countered.</p>
<p>The turning back kick (and jump) are aimed at the torso.</p>
<p>The outside sweep (and jump) are aimed at the neck and spine.</p>
<p>The reverse r/house also at the neck and spine or facial area.</p>
<p>The turning(r/house/outside twist?) is at the neck only, the shoulder only as a secondary target.</p>
<p>Use maximum penetration on these kicks.</p>
<h3 id="65-fan-hand">[65] Fan Hand</h3>
<p>Used mainly to these as a disruption technique in order to allow the use of the better destruction moves. The fan hand is basically a straight finger technique used with a large spread of the fingers against a fast moving opponent or an unclear (obstructed) view of your adversary. The fan hand idea is that at least one finger should hit the eye - rather than attempt to hit the eye with all fingers. Your second target should be as far away from the eye as possible, so as to prevent an easy parry.</p>
<p>Use a shooting finger type technique with this.</p>
<h3 id="66-utilising-arm-damage-through-kicking">[66] Utilising Arm Damage through Kicking</h3>
<p>Trap the lead arm of your opponent. Pull it across you then kick it. Generally you hit large muscle groups. But you can capitalise on this by kicking close to the joints thereby increasing the chance of joint dislocation or interruption of the arm altogether. If your opponent closes too much then kick his thigh or above his hip in order to give you kicking space. Having kicked the arm once to weaken it - don’t hesitate to twist the hand/ wrist so as to expose a more sensitive area to your next kick. You can alternate between the lead arm and leg so as to keep your opponent static and maintain a safe distance between you.</p>
<p>Watch for your opponent lifting his elbow, if so kick his lead leg as he’s attempting to position for a kick. Be direct as possible foot to arm using the shortest distance possible. Do not use too much power - you are only trying to isolate his lead arm not destroy it. Jump kicking the lead arm is not recommended as this causes your opponent to lean back severely - thereby pulling you forward on recovery. Not a good idea.</p>
<h3 id="67-kicking-as-a-stop-gap">[67] Kicking as a Stop-Gap</h3>
<p>To prevent your opponent moving or stepping - kick his lower legs - to prevent his kicking you - kick his upper legs.</p>
<p>Kicking to your opponents advanced leg has several objectives;</p>
<ol class="numbered">
  <li>To stop all further aggression.</li>
  <li>To end the fracas by him due to him being unable to continue.</li>
  <li>To create a pause in his movement due to pain or fear.</li>
  <li>As a preparation, prior to continue an attack on him.</li>
  <li>To deprive him of movement or restrict his area.</li>
  <li>As a disengagement to prevent his following you.</li>
</ol>
<h3 id="68-attacking-the-neck">[68] Attacking the Neck</h3>
<p>Used to isolate the body. Striking the neck deprives the body of all the constructive movement. When grappling always attack the neck as the neck controls the body.</p>
<p>Attempting to break the neck robs the legs of all power and prevents most movements or the arms.</p>
<p>So basically, attacking the neck is a premium target due to its effect on the body.</p>
<p>The spine at the rear of the neck is the best target due to its solid construction - the windpipe and carotid arteries are the next most valued target due to its face - front value.</p>
<h3 id="69-foot-stamping">[69] Foot Stamping</h3>
<p>Used to isolate a single leg or to lift his leg due to pain - thereby presenting a static target.</p>
<p>If he lifts his leg, you have the option of either attacking his raised thigh or his standing leg. The raised leg requires little power but the standing leg uses more strength as it’s his weight bearing leg. Snap at the first and drive into the other. When you stamp on his foot - always hit the instep as close as possible to the shin. It’s mainly a distraction technique, but can be extremely useful.</p>
<p>Use this stamp in combination with a leg attack - you can either hit the leg you’ve attacked or change to his other leg. Sometimes when you hit his instep he leans away - facilitating a knee stamp or strike.</p>
<p>You can also use jump - kicks with a foot stamp.</p>
<p>Knees can also be used with this.</p>
<p>If he leans toward you then simply push him away - prior to striking.</p>
<p>Scoop kicks are useful with a foot stamp: Do not use too much power with this as it leaves you static as well</p>
<h3 id="70-throws">[70] Throws</h3>
<p>Is basically an economy of motion tactic;</p>
<ul>
  <li>If your opponent is thrown well, then it affords you extra time as he regains an upright position ( though why you’d allow him the chance to do so is beyond me )</li>
  <li>If he’s thrown on an uneven surface or very hard surface - it increases the chances of more serious injury to him.</li>
  <li>As an objective it’s a good idea to attempt to land him on his neck or head. Remember only sporting styles of grappling throw their opponent on his side - this is no good for Ming Chuan.</li>
  <li>Throwing puts your opponent in a great distress - as whilst falling and just after landing - he’s not thinking of defending himself against your continued assault. Capitalise on this.</li>
  <li>Always grab a sensitive spot on your opponent so as to insure his compliance with your technique. He will not resist due to the pain involved in the technique.</li>
  <li>Pain also prevents his attempt of trying to &#x27;break fall&#x27; on impact with the ground.</li>
  <li>Remember downing your adversary in NOT the end of your technique. Re - attack at his different level. Legs fist if he’s larger - .</li>
</ul>
<h3 id="71-maintaining-vigilance">[71] Maintaining Vigilance</h3>
<ul>
  <li>Do not hold a ‘downed opponent’.</li>
  <li>Do not hold a sitting opponent.</li>
  <li>Do not hold a standing opponent, even if your opponent is in a disadvantages position.</li>
</ul>
<p>The reason for this is that holding anyone demands concentration - your concentration is best reserved for the surrounding environment - on the look - out for his friends etc, therefore you have nothing to do with your opponent - render him incapable of further aggression.</p>
<ul>
  <li>Also do not kneel or sit on him</li>
  <li>Do not stand on him either</li>
  <li>Remember the fracas should last between 3 to 5 seconds - no more than this. Then immediately resume your vigilance - if he’s recovering then strike again</li>
</ul>
<p>It’s so simple but so easily forgotten.</p>
<p>Do not use arm locks - wrist locks - leg locks - head locks etc, as all these hold your opponent and robs you of vigilance</p>
<ul>
  <li>Chokes and strangles are o.k. as these progressively render your opponent helpless and are worth a slight lapse in vigilance.</li>
  <li>Your opponent should only grab a couple of seconds of your time - then it’s over.</li>
</ul>
<h3 id="72-hitting">[72] Hitting</h3>
<p>Remember everyone has the same organs and vital points - therefore everyone reacts the same way:</p>
<ul>
  <li>If your opponent is hit precisely then he’s down. Power is not a requirement in hitting vital points so you must list the areas that require little strength to succeed. This way you may strike rapidly and effectively.</li>
</ul>
<p>Regardless of your strength - what is required is a fast - penetrating strike that uses little strength.</p>
<p>Strength is likened to swinging a baseball bat - fine if it hits, but it misses then it’s a liability.</p>
<p>Study all methods and all nerve centres - in order to render your striking ability precise.</p>
<p>This gives you an ageless ability to strike instead of the normal 20 odd years that the normal strength idea gives to striking usefulness.</p>
<ul>
  <li>It must be stated that the object of striking is to cause your opponent the fall to the ground - thus facilitating a stamp or two to end the event.</li>
  <li>Continue to strike until you’ve achieved the desired result.</li>
</ul>
<h3 id="73-the-press">[73] The Press</h3>
<p>Is always followed by a low disabling kick or stamp - using a press always leads to a lean back by your opponent.</p>
<p>Sometimes, while using the press to an already injured or disabled opponent, it’s possible o strike into your opponents head or neck but followed immediately by a low kick.</p>
<p>If your lead hand maintains contact with your opponents elbow throughout your technique - then it’s safe to hit any area you wish (bearing in mind its better to spend some time hindering his movement)</p>
<p>If on the other hand your hand is distancing itself from your opponents elbow - then your adversary is retreating - stopping this action now takes your attention. Low kick repeatedly in to his lead leg.</p>
<p>In the event that your hand makes stronger contact with his elbow than anticipated then he’s advancing - use elbows especially into his lead arm and back this prevents two problems for you, his lead hand coming on target and any attempt by him to bring his rear hand to bear either directly or with a turning maneuver. Trust your lead hand to determine and anticipate your opponent’s intentions. It’s necessary to practice all the above in a loose drill to aid sensitivity and enhance reactions.</p>
<h3 id="74-deflections">[74] Deflections</h3>
<p><em><strong>Back fist the lead hand</strong></em><strong>:</strong></p>
<p>Fast and efficient - causes withdrawal of the lead body tool / deflection of your adversary’s defensive line. Pain /confusion / disruption of cohesive defence by him.</p>
<p><em><strong>Hammer fist</strong></em><em><strong> his lead forearm (radial nerve):</strong></em></p>
<p>Which causes deadening of lower arm and grip - fingers don’t reply stimuli. Numbness of said arm - great pain (distraction) - enough on its own to allow entry or withdrawal with total safety.</p>
<p><em><strong>Feng-yen to his brachialis:</strong></em></p>
<p>Numbness of upper arm - deadened fingers loosened grip etc. Pain causes lean back by him - so follow with attack o lead leg.</p>
<p><em><strong>Triceps and Biceps attack</strong></em><em><strong>:</strong></em></p>
<p>Using elbow for example; great pain / numbness - total loss of arm - causes lean - either way depending on muscle attacked - for lean back, attack his leg next / for lean fore ward attack his neck.</p>
<p><em><strong>Punch to shoulder</strong></em><em><strong>:</strong></em><strong> </strong></p>
<p>Total loss of arm - also causes turning of opponent - so watch his other arm / shoulder. If he attempts to use other arm, attack the centre of his chest with Feng - yen - this negates the use of his other arm. Continue attack on his lead arm - forearm in general - so as to complete the assault on his lead.</p>
<p><em><strong>Midpoint inside forearm:</strong></em></p>
<p>Relaxation of grip - numbness of fingers - attack the biceps next in combination as it takes out the upper arm too, thus enabling the safe entry and exit.</p>
<p><em><strong>Midpoint outside forearm</strong></em><em><strong>:</strong></em></p>
<p>Loosening grip, numbing fingers relaxing wrist.</p>
<p>This attack has the advantage of closing the arm across the body, thus negating the use of his rare hand. Use Hammerfist to triceps or traps to complete the attack.</p>
<p><em><strong>Attack on inner arm: </strong></em></p>
<p>Between biceps and triceps; Very rare - attack the nerves related to the ulna and fingers / fingers shoot open and cannot close for several seconds - Arm dead - attack high point on forearm in combination with this.</p>
<p>Other deflections are simpler;</p>
<ol class="numbered">
  <li>sweep the elbow to one side / across his rare hand</li>
  <li>claw a nerve and pull downwards in order to negate the use of his lead leg</li>
  <li>Press the lead arm (elbow and above) to his side - in order to hinder any constructive movement by him.</li>
  <li>The Croise - sweep a downward trap on his lead wrist / forearm and lead it downward and across his body to interrupt the use of his rare arm and lead leg. Whilst keeping downward pressure on his lead arm - attack it - attack his lead arm - kick his lead arm if he attempts to pull away. Don’t use the Croise as a sole guarantee upon entry - use other methods as well.</li>
</ol>
<h3 id="75-punishment">[75] Punishment</h3>
<ul>
  <li>Repeated attacks on the same point</li>
  <li>Varied attacks on major muscles on the lead body tools.</li>
  <li>Joint strikes in combination</li>
  <li>Repeated claws to major areas (disruption)</li>
  <li>Knuckle point strikes to weak - points</li>
  <li>Point striking to interfere with airways</li>
  <li>Repeated groin hitting in combination</li>
</ul>
<p>These strikes have both a physical and psychological effect on your opponent and should not be undervalued. Regular practice of the above is always encouraged, and leads to your adversary’s defeat or withdrawal due to pain or injury. It is then your decision to be merciful or ruthless, which I suggest rests solely on the fight your opponent’s put up. Or your anticipation of a further encounter with him in the future.</p>
<p>Remember all physical encounters finish due to pain (discouragement) or force (when hit hard enough to cause unconsciousness or disorientation). With aggression most opponents are subdues. Only aggressive opponents are de - fanged by scarring or disfigurement. If your gauge your opponent thusly then act within these guidelines. Do not be squeamish regarding pursuing your objectives, as this prevents further encounters with a previously defeated opponent. If someone reengages you after a previous encounter, you are loosing, as he did not learn his lesson in the first place. We are talking total victory physical and psychological.</p>
<p>Some people are not convinced by a split lip, or bleeding nose.</p>
<h3 id="76-trapping">[76] Trapping</h3>
<p>Whilst trapping - if your opponent attempts to retreat, then kick low. If he attempts to advance then elbow.</p>
<p>If he stands there - then destroy his lead arm with a combination attack.</p>
<p>If he tries to duck or fall, then knee or stamp.</p>
<p>Do not wait for his reaction, whilst trapping - go ahead and follow your pattern. If he begins to react as above, then use the above solutions.</p>
<p>Trapping is an excellent technique which allows you to hit whilst avoiding any counter. It also allows you to employ leg destruction techniques in safety.</p>
<p>When trapping always disengage with a low kick.</p>
<p>Trapping also allows the use of grappling combos, joint locks, sleeper holds etc.</p>
<p>It is used in weapon styles and for de-fanging the snake.</p>
<p>The hallmark of a good martial artist is his trapping ability.</p>
<p>[77] The Slap</p>
<ul>
  <li>Shock tactic used as a stunner or delay technique, your opponent’s initial reaction is to freeze. He is stunned for a second or two, no more. So be prepared after you’ve slapped to deliver a telling blow, which depends on your opponents body type - only superseded by a threat he presents or weapon he carries.</li>
  <li>Used in order to isolate a major muscle group for the purpose of disablement. To hinder movement or technique, to prevent a counter to your combination. This is mainly used a disengagement.</li>
  <li>A slap to the face causes facial neuralgia, listed as the worst pain experienced. Hitting between the temple and jaw line this blow strikes a major ganglia of nerves which control all facial muscles.</li>
  <li>As a minor response to a situation (minimum violence) Used as a restraint, or prior to a take down. It is a minor technique in your arsenal, but practiced because not all confrontations is life threatening.</li>
  <li>Hitting the ribs or back in order to forcibly expel air from his lungs, the method slows your opponent and his movement. This technique robs your adversary of his strength.</li>
  <li>Slapping your opponents attacking arm or leg robs it of coordination and power. It redirects it on extension and contraction (return) thus preventing any coordination of movement by him. This is used to interrupt combination techniques by a superior coordinated opponent.</li>
  <li>Always try to slap in a downwards motion, as this roots your opponent to the spot. Downward motion is faster than any other movement as it is gravity assisted</li>
  <li>Major arteries are also a great target as you get the added bonus of blood pressure hitting the basement, his lack of coordination and sudden weakness are guaranteed.</li>
  <li>The groin slap although last in this list is perhaps the most valuable of all. As a shock tactic it’s second to none. It achieves many things, anchoring both your opponent’s feet to the ground. Halting his movement, stopping all constructive technique by him. Doubling up your opponent, causing his confusion etc...</li>
</ul>
<h3 id="78-hair-pulling">[78] Hair Pulling</h3>
<ul>
  <li>Used mainly as a control technique, to inhibit or predict your opponent’s movement.</li>
  <li>To draw your adversary in to an advantageous position in order to expose striking areas that were previously better defended.</li>
  <li>As a method of confusion (pain)</li>
  <li>Used in conjunction with a trip or throw, downing your opponent on his head or neck.</li>
  <li>To deliver a more powerful blow, as a static or controlled adversary is an easier subject than a moving one.</li>
  <li>In order to deliver a slower technique, which has a predictable path.</li>
  <li>To stabilise him prior to spinal attacks or low leg techniques.</li>
  <li>Prior to neck - breaking strikes.</li>
</ul>
<p>When doing this technique the hair at the nape of the neck is preferable due to the gathering of nerves in that area. Next to that the hair in front of the ears (locks), are best. To prevent your opponent kicking, pull him as low as possible, watch his shoulders, to prevent hand attacks. Do not allow your other hand to stray out of striking distance as this hand can be used should he attempt to interfere with your hair grab. Should he attain the prone / face down position then disengage by stamping on one of his ankles.</p>
<h3 id="79-the-gap">[79] The Gap</h3>
<p>Is the art of creating a hesitation or space in your opponents rhythm - this is different from phasing time. There are numerous ways of causing a gap.</p>
<ul>
  <li>Attack or pretend to attack as your opponent attacks you - this threat causes a pause in his movement - however small.</li>
  <li>Kick low - this causes a withdrawal of his leg (as a defence) or a hesitation in his step</li>
  <li>A push or shove causes a misdirection of his intent as he must fight for balance, regardless of his desire.</li>
  <li>Pulling him onto you - causes tension in his lead leg (dorsal muscle) ‘heavy leg’ due to his reluctance to engage you on what he perceives as “your” distances’ favourite technique.</li>
  <li>Any threat which causes a change in his initiation - thereby causing a re - evaluation in his psyche. A change to his technique.</li>
</ul>
<p>All this sets up the pre - conception by him that you master the situation. It causes accusation of aggression, a gradual slowing - down of the desire for victory by your adversary. It’s at this point that you double your efforts. This is the moment of reprise - when you take the advantage of his confusion.</p>
<p>Needless to say your technique at this point causes him great pain or extensive damage, leading to the conclusion of the fight.</p>
<h3 id="80-flicking">[80] Flicking</h3>
<p>Despised and frowned upon by the traditionalist, the term flicking suggests a loose, rapid, powerless type of blow thrown by either hand or foot. The argument put fore ward by some Northern styles and Ming - Chuan is that when striking at a moving opponent he is un stable, therefore its pointless to entertain powerful blows as this only wastes energy. Instead rapid multiple striking is employed. So why not a flicking type blow:</p>
<ul>
  <li>It uses little energy</li>
  <li>facilitates rapid movement</li>
  <li>employs spring - like hitting on extension and retrieval therefore no hanging around in the event of a miss</li>
  <li>aid hand and foot coordination</li>
  <li>It goes without saying that having hit with a couple of these stingers, you then use more leverage.</li>
  <li>Used with ‘tam toy’ this method has proved itself in combat.</li>
</ul>
<p>This method is employed until your adversary becomes stable i.e. flatfooted or up against something solid, or prone. Power should only be employed in these circumstances.</p>
<p>This method relates to free - play and can be overridden in set - play, that is, when your opponent is static and is position for a rehearsed opener.</p>
<h3 id="81-target-opportunity">[81] Target Opportunity</h3>
<p>If your opponent is slower than you, then you can target any individual body part at will. Strike any lead body tool with both speed and power to inflict maximum damage. The problem arises when he’s faster or more mobile than you i.e. quicker with his hands or feet or both</p>
<p><em>Quicker with </em><em>hands</em>; hit the upper arms - as this body part moves at half the speed of the hand and should be easier to isolate, thereby shutting down the entire arm. Sometimes it’s a good idea that after hitting the arm once and perhaps slowing it slightly, hit it again. Doubling up on hits is a good motto to adopt, for the insecure. Pressing the upper arm then follow with an elbow is good, just remember to elbow close to the shoulder as regardless of his hand speed, his shoulder never moves, just rotates.</p>
<p><em>Quicker with feet</em><em>;</em> hit above knees, yet below the hip. The upper leg. This disables the entire leg and forces him to stand with a straight leg, making a joint attack easy. His prior mobility would have made this a difficult strike. Study combination attacks against the legs. Having struck the leg then incorporate a knee strike to his thigh, in order to enhance the damage to your opponent. Look into downing your adversary as a possible delaying factor.</p>
<p>Essentially, repeated strikes into the same area slow your opponent down.</p>
</main>
</article>

<script>
(function () {
  var root = document.documentElement;
  function apply(msg) {
    if (!msg || typeof msg !== 'object') return;
    if (msg.type === 'tao2:font') {
      if (msg.family) root.style.setProperty('--reader-font', msg.family);
      if (msg.size) root.style.setProperty('--reader-size', msg.size + 'px');
    } else if (msg.type === 'tao2:scrollTo' && msg.id) {
      var el = document.getElementById(msg.id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  // Native WebView injects: window.__tao2Apply(jsonString)
  window.__tao2Apply = function (json) { try { apply(JSON.parse(json)); } catch (e) {} };
  // Web iframe: parent posts structured messages
  window.addEventListener('message', function (e) {
    var d = e.data;
    if (typeof d === 'string') { try { d = JSON.parse(d); } catch (_) { return; } }
    apply(d);
  });
  function send(msg) {
    var s = JSON.stringify(msg);
    if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
      window.ReactNativeWebView.postMessage(s);
    } else if (window.parent && window.parent !== window) {
      window.parent.postMessage(msg, '*');
    }
  }
  var heads = [].slice.call(document.querySelectorAll('h2[id], h3[id]'));
  var ticking = false, lastId = null;
  function spy() {
    ticking = false;
    var se = document.scrollingElement || document.documentElement;
    var y = se.scrollTop || 0;
    var cur = heads.length ? heads[0].id : null;
    for (var i = 0; i < heads.length; i++) {
      var top = heads[i].getBoundingClientRect().top + y;
      if (top <= y + 90) cur = heads[i].id; else break;
    }
    if (cur && cur !== lastId) { lastId = cur; send({ type: 'tao2:active', id: cur }); }
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(spy); }
  }, { passive: true });
  send({ type: 'tao2:ready' });
  setTimeout(spy, 80);
})();
</script>

</body>
</html>
`;
